import _ from 'lodash';

import AgentPhonePreferences from 'models/agent_phone_preferences';
import AgentVoiceConfiguration from 'models/agent_voice_configuration';
import PutUserBase from './put_user_base';

export default class CreateUser extends PutUserBase {
  runAction(editableUser) {
    let appFeatures = this.context.stores.appFeatures.get();
    // Check value of `webRTC` in `gateKeeperFeatures` directly as `appFeatures.isEnabled('webRTC`) returns false on IE11
    let isWebRTCEnabled = _(appFeatures.gatekeeperFeatures).get('webRTC');
    let isTelephonyApiEnabled = appFeatures.isEnabled('telephonyApi');
    let isSipEnabled = appFeatures.isEnabled('sip');
    let voiceConfiguration;
    if (isWebRTCEnabled) {
      voiceConfiguration = AgentVoiceConfiguration.create({ preference: AgentPhonePreferences.BROWSER });
    } else if (isTelephonyApiEnabled || isSipEnabled) {
      voiceConfiguration = AgentVoiceConfiguration.create({
        stationId: editableUser.stationId,
        preference: editableUser.stationId ? AgentPhonePreferences.STATION : AgentPhonePreferences.NONE,
      });
    } else {
      voiceConfiguration = AgentVoiceConfiguration.create({ preference: AgentPhonePreferences.NONE });
    }

    let agentUserAttrs = {
      ...editableUser,
      username: editableUser.email,
      voiceConfiguration: voiceConfiguration.toJs(),
    };
    if (editableUser.disabled) {
      agentUserAttrs.disabledAt = new Date().toISOString();
    }

    this.context.gateways.agentUser.add(_.omit(agentUserAttrs, ['id', 'disabled']));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/create_user.js